import React, { useEffect, useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi } from '../apiService'
import { globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { useNavigate, useParams } from 'react-router-dom'
import { PageLoader } from '../../../shared_elements'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { trackActivity } from '../../../utils/mixpanel'
import { getAdditionalTax, getTotalTax } from '..'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddSecurityDepositInv = ({ toggleInvModel, modeType, item, securityDepositInvoice, setSecurityDepositInvoice }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params= useParams();
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const { enqueueSnackbar } = useSnackbar();
    const [attachments, setAttachments] = useState([]);
    const [tableErrors, setTableErrors] = useState({});
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false)
    const [activeTaxList, setActiveTaxList] = useState([]);
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    
    const onAddEditInvoice = () => {
        let validationInputs = {
            invoice_number: securityDepositInvoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
            date: securityDepositInvoice?.date ? '' : 'Please select Invoice Date',
            due_date: securityDepositInvoice?.due_date ? '' : 'Please select Invoice Due Date',
            currency: securityDepositInvoice?.currency ? '' : 'Please select Currency',
            bank: securityDepositInvoice?.bank?.id ? '' : 'Please select Bank',
        }

        const invoiceDate = moment(securityDepositInvoice?.date);
        const dueDate = moment(securityDepositInvoice?.due_date);
        const maxAllowedDate = moment(leaseBasicDetails?.end_date).add(3, 'months');
        if (securityDepositInvoice?.date && securityDepositInvoice?.due_date) {
            if (dueDate.isBefore(invoiceDate)) {
                validationInputs.due_date = "Due Date cannot be before Invoice Date";
            }
            if (invoiceDate.isAfter(dueDate)) {
                validationInputs.date = "Invoice Date cannot be after Due Date";
            }
            if (invoiceDate.isBefore(leaseBasicDetails?.start_date)) {
                validationInputs.date = `Invoice Date cannot be before Lease Start Date`;
            }
            if (invoiceDate.isAfter(maxAllowedDate)) {
                validationInputs.date = "Invoice Date must be within 3 months after the Lease End Date.";
            }
            if (dueDate.isAfter(maxAllowedDate)) {
                validationInputs.due_date = "Due Date must be within 3 months after the Lease End Date.";
            }
            if (dueDate.isBefore(leaseBasicDetails?.start_date)) {
                validationInputs.due_date = "Due Date cannot be before Lease Start Date";
            }
            if (invoiceDate.isBefore(securityDepositInvoice?.start_date)) {
                validationInputs.date = "Invoice Date cannot be before Period Start Date";
            }
            if (dueDate.isBefore(securityDepositInvoice?.start_date)) {
                validationInputs.due_date = "Due Date cannot be before Period Start Date";
            }
            if (securityDepositInvoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (securityDepositInvoice?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
        }
        setError({ ...validationInputs });

        let newErrors = {};
        securityDepositInvoice.invoice_items.forEach((row, index) => {
            const errors = {};

            if (!row.description?.trim()) {
                errors.description = "Please enter Security Against";
            }

            if (row.sub_total === '' || row.sub_total === null || row.sub_total === undefined) {
                errors.sub_total = "Please enter Amount.";
            } else if (parseFloat(row.sub_total) <= 0) {
                errors.sub_total = "Please enter an Amount greater than 0.";
            }

            if (Number(row.sub_total) > Number(row.original_amount)) {
                errors.sub_total = "Amount can't exceed Security Deposit Amount";
            }

            if (isQbEnabled && !row.qb_product_and_service_id) {
                errors.qb_product_and_service_id = "Please select Product & Service";
            }

            if (isQbEnabled && !row.qb_chart_of_account_id) {
                errors.qb_chart_of_account_id = "Please select Chart of Account";
            }

            if (isQbEnabled && !row.qb_class_id) {
                errors.qb_class_id = "Please select Class";
            }

            if (isQbEnabled && !row.qb_sub_class_id) {
                errors.qb_sub_class_id = "Please select Sub Class";
            }

            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });

        setTableErrors(newErrors)
        if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
            trackActivity(`Item Added`, { page_title: 'Add Security Deposit Invoice', error_msg: validationInputs, })
            return;
        }

        let payload = Object.assign({}, securityDepositInvoice)

        payload = {
            invoice_number: securityDepositInvoice?.invoice_number || null,
            start_date: securityDepositInvoice?.start_date || null,
            end_date: securityDepositInvoice?.end_date || null,
            date: securityDepositInvoice?.date || null,
            due_date: securityDepositInvoice?.due_date || null,
            currency: securityDepositInvoice?.currency?.code || null,
            bank: securityDepositInvoice?.bank || null,
            from: securityDepositInvoice?.from || null,
            to: securityDepositInvoice?.to || null,
            remarks: securityDepositInvoice?.remarks || null,
            invoice_type: { label: 'Security Deposit', value: 6 },
            footer_note : securityDepositInvoice?.bank?.footer_note || null,
            asset : securityDepositInvoice?.asset ? securityDepositInvoice?.asset : null,
            trustee_id : securityDepositInvoice?.trustee_id ? securityDepositInvoice?.trustee_id : null,
            invoice_items: Array.isArray(securityDepositInvoice?.invoice_items)
                ? securityDepositInvoice.invoice_items.map((items) => {
                      const subTotal = Number(items?.sub_total) || 0;
                      const taxRate = Number(items?.tax_rate) || 0;
                      const taxAmount = subTotal * (taxRate / 100);
                      const subAmountTotal = subTotal + taxAmount;
                      return {
                invoice_item_name: items?.invoice_item_name ? items?.invoice_item_name : null,
                description: items?.description ? items?.description : null,
                sub_total: items?.sub_total ? items?.sub_total : 0,
                no_of_units: items?.no_of_units ? items?.no_of_units : null,
                tax_rate: normalizeTaxRate(items?.tax_rate),
                tax_amount: items?.tax_amount ? Number(items?.tax_amount) : 0,
                rate_per_unit: items?.rate_per_unit ? items?.rate_per_unit : 0,
                sub_amount_total: subAmountTotal.toFixed(4),
                sub_reference_id: items?.sub_reference_id,
                qb_product_and_service: items?.qb_product_and_service_id || null,
                qb_chart_of_account: items?.qb_chart_of_account_id || null,
                qb_class: items?.qb_class_id || null,
                qb_sub_class: items?.qb_sub_class_id || null,
            };
                  })
                : [],
        };
        let updatedInvoiceItems = getAdditionalTax(payload?.invoice_items, activeTaxList)
        let tax_details = getTotalTax(payload?.invoice_items, activeTaxList)
        setLoading(true);
        globalPostService(addInvoiceApi(), { ...payload, tax_details:tax_details, invoice_items:updatedInvoiceItems, lease_slug: params?.leaseSlug })
            .then(response => {
                if (checkApiStatus(response)) {
                    if (attachments?.length) {
                        dispatch(setUploadFiles({ modal: true, slug: response?.data?.data?.slug }));
                    }
                    toggleInvModel()
                    trackActivity('Item Added', { page_title: `Add Security Deposit Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                    setLoading(false);
                    navigate(`/invoices/view/${response?.data?.data?.slug}`,{ state: { from: 'viewFromLease' } })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    setLoading(false);
                    trackActivity('Item Added', { page_title: `Add Security Deposit Invoice`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                }
            })
    };

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                let taxAmount = 0;
                let subTotal = 0;

                if (keyParam === "sub_total") {
                    subTotal = parseFloat(value) || 0;
                    if (securityDepositInvoice.invoice_items[itemIndex].tax_rate) {
                        taxAmount = subTotal * (parseFloat(securityDepositInvoice.invoice_items[itemIndex].tax_rate) / 100);
                    }
                } else {
                    subTotal = parseFloat(securityDepositInvoice.invoice_items[itemIndex].sub_total) || 0;
                    if (value) {
                        taxAmount = subTotal * (parseFloat(value) / 100);
                    }
                }

                const subAmountTotal = subTotal + taxAmount;

                setSecurityDepositInvoice({
                    ...securityDepositInvoice,
                    invoice_items: securityDepositInvoice.invoice_items.map((item, index) =>
                        index !== itemIndex
                            ? item
                            : {
                                ...item,
                                [keyParam]: value,
                                tax_amount: taxAmount.toFixed(4),
                                sub_amount_total: subAmountTotal.toFixed(4),
                            }
                    ),
                });
            } else {
                setSecurityDepositInvoice({
                    ...securityDepositInvoice,
                    invoice_items: securityDepositInvoice.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value, ...(keyParam === 'qb_class_id' ? { qb_sub_class_id: null } : {}) }
                    ),
                });
            }
        } else {
            setSecurityDepositInvoice({ ...securityDepositInvoice, [keyParam]: value });
        }
    };

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const resetTableError = (rowIndex, fieldName) => {
        setTableErrors((prevErrors) => {
            const rowErrors = { ...prevErrors[rowIndex] };
            delete rowErrors[fieldName];

            const updatedErrors = { ...prevErrors };
            if (Object.keys(rowErrors).length === 0) {
                delete updatedErrors[rowIndex];
            } else {
                updatedErrors[rowIndex] = rowErrors;
            }

            return updatedErrors;
        });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Add Security Deposit Invoice`, page_type: page_type, })
    }
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' {...getInvoiceDialogWidthProps({ invoice: securityDepositInvoice, type: 'securityDepositInvoice', activeTaxList, showQbFields: isQbEnabled }, 'xl')} open={true} style={{ overflowY: "unset" }} >
                <DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
                    Add Security Deposit Invoice
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <AInvbasicDetail addEditInvoice={securityDepositInvoice} type={'securityDepositInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={securityDepositInvoice} error={error} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} leaseSlug={params?.leaseSlug} onActiveTaxLoad={setActiveTaxList} onQbStatusLoad={setIsQbEnabled}/>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { toggleInvModel(); handleItemClicked('Cancel Button') }} > Cancel </Button>
                    <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice(); }}>
                        {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default AddSecurityDepositInv